var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactUs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Language",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_337",
    "data-name": "Union 337",
    d: "M24749.164,5502.318a2.109,2.109,0,1,1,0-4.217h1.3a2.107,2.107,0,0,1,1.852,1.106,3.759,3.759,0,0,0,2-1.6,2.108,2.108,0,0,1-1.387-1.975v-2.622a2.107,2.107,0,0,1,1.955-2.1,5.07,5.07,0,0,0-10.135-.122,2.109,2.109,0,0,1,1.951,2.1v2.615a2.074,2.074,0,0,1-.611,1.492,2.133,2.133,0,0,1-1.49.623h-1.3a2.111,2.111,0,0,1-2.1-2.115v-2.615a2.1,2.1,0,0,1,1.955-2.1,6.671,6.671,0,0,1,6.66-6.467h.063a6.669,6.669,0,0,1,6.605,6.589,2.12,2.12,0,0,1,1.963,2.109v2.616a2.108,2.108,0,0,1-2.107,2.109h-.295a5.354,5.354,0,0,1-3.568,3.08,2.106,2.106,0,0,1-2,1.5Zm-.508-2.108a.511.511,0,0,0,.508.507h1.3a.51.51,0,0,0,.359-.868.532.532,0,0,0-.359-.147h-1.3A.507.507,0,0,0,24748.656,5500.209Zm6.016-7.555a.521.521,0,0,0-.148.361v2.616a.505.505,0,0,0,.148.354.5.5,0,0,0,.359.147h1.3a.476.476,0,0,0,.354-.147.485.485,0,0,0,.152-.354v-2.616a.5.5,0,0,0-.152-.361.478.478,0,0,0-.354-.146h-1.3A.5.5,0,0,0,24754.672,5492.655Zm-11.729-.122a.481.481,0,0,0-.154.355v2.615a.5.5,0,0,0,.154.361.5.5,0,0,0,.354.146h1.3a.5.5,0,0,0,.506-.507v-2.615a.514.514,0,0,0-.506-.508h-1.3A.505.505,0,0,0,24742.943,5492.533Z",
    transform: "translate(-22876.193 -5388.318)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/icon_contact_us.adc6aca832d8dd971c9858e677b1ea00.svg";
export { ForwardRef as ReactComponent };